import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/product-details/[slugid]/ProductDetails.jsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/assets/not-found-image.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/styles/css/products.scss");
